import React from 'react';
import PropTypes from 'prop-types';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '../TextField';
import { SlackChannelSelect } from './SlackChannelSelect';

function InfoChannelEdit({ field, model }) {
	return (
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<Card>
					<CardContent>
						<Typography variant="h3">
							Email
						</Typography>
						<Grid container spacing={2}>
							<Grid item xs={12}>
								<TextField
									{...field('mailAddresses')}
									fullWidth
									label="Mail address(es)"
									emails
								/>
							</Grid>
						</Grid>
					</CardContent>
				</Card>
			</Grid>
			<Grid item xs={12}>
				<SlackChannelSelect model={model} />
			</Grid>
		</Grid>
	);
}

InfoChannelEdit.propTypes = {
	field: PropTypes.func.isRequired,
	model: PropTypes.any,
};

InfoChannelEdit.defaultProps = {
};

export default InfoChannelEdit;
